"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

export const SectionComponent: RegisteredComponent = {
  name: "Core:Section",
  override: true,
  component: dynamic(async () => (await import("./Section")).Section),
  canHaveChildren: true,
  inputs: [
    {
      name: "children",
      type: "uiBlocks",
      defaultValue: [],
      hideFromUI: true,
    },
  ],
};
